import { BundleSignPostUI } from "./BundleSignPostUI";
import { StandardProps } from "../componentMap";

export const BundleSignPost = ({ product }: Pick<StandardProps, "product">) => {
  if (product.__typename !== "RetiredStaticBundle") return null;

  return <BundleSignPostUI title="Bundle" />;
};
